import Column from "@/components/Ui/Column";
import { Button } from "@/components/shadcn/button";
import { captureException } from "@/utils/tracking";
import type { ErrorInfo, ReactNode } from "react";
import { Component } from "react";

type Props = {
  children: ReactNode;
  fallback?: ReactNode;
};

type State = {
  hasError: boolean;
  error: Error | null;
};

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    if (error.name === "ChunkLoadError") {
      if (!sessionStorage.getItem("chunk-error-refreshed")) {
        sessionStorage.setItem("chunk-error-refreshed", "true");
        window.location.reload();
      }
    }
    captureException(error, {
      component_stack: errorInfo.componentStack ?? "unknown",
    });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <Column className="min-h-[200px] gap-4 p-8">
          <div className="text-destructive text-xl font-medium">
            Something went wrong
          </div>
          <Button
            onClick={() => this.setState({ hasError: false, error: null })}
          >
            Try again
          </Button>
        </Column>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
